import React, { useState } from 'react';
import { menuCategories } from '../data/mockData';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';

const Menu = () => {
  const [activeCategory, setActiveCategory] = useState(menuCategories[0].id);

  return (
    <section id="menu" className="py-20 bg-gradient-to-b from-yellow-50 to-pink-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-pink-500">Menu</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 to-pink-400 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Explore our diverse range of authentic North Indian vegetarian dishes, 
            from tandoor specialties to street food favorites
          </p>
        </div>

        {/* Menu Tabs */}
        <Tabs defaultValue="1" className="w-full">
          <TabsList className="w-full flex flex-wrap justify-center gap-2 mb-12 bg-transparent h-auto p-0">
            {menuCategories.map((category) => (
              <TabsTrigger
                key={category.id}
                value={category.id.toString()}
                onClick={() => setActiveCategory(category.id)}
                className="bg-white data-[state=active]:bg-gradient-to-r data-[state=active]:from-yellow-400 data-[state=active]:to-pink-400 data-[state=active]:text-gray-800 text-gray-600 px-6 py-3 rounded-lg font-semibold shadow-sm hover:shadow-md transition-all"
              >
                {category.name}
              </TabsTrigger>
            ))}
          </TabsList>

          {menuCategories.map((category) => (
            <TabsContent key={category.id} value={category.id.toString()}>
              <Card className="border-2 border-yellow-200 shadow-lg">
                <CardHeader className="bg-gradient-to-r from-yellow-50 to-pink-50">
                  <CardTitle className="text-3xl font-bold text-gray-800">
                    {category.name}
                  </CardTitle>
                  {category.description && (
                    <CardDescription className="text-lg text-gray-600 mt-2">
                      {category.description}
                    </CardDescription>
                  )}
                </CardHeader>
                <CardContent className="pt-6">
                  <div className="grid sm:grid-cols-2 gap-4">
                    {category.items.map((item, index) => (
                      <div
                        key={index}
                        className="group bg-white hover:bg-gradient-to-r hover:from-yellow-50 hover:to-pink-50 rounded-lg p-4 border-2 border-gray-100 hover:border-yellow-300 transition-all duration-300 shadow-sm hover:shadow-md"
                      >
                        <div className="flex justify-between items-start mb-2">
                          <h4 className="font-bold text-lg text-gray-800 flex-1">
                            {item.name}
                          </h4>
                          <div className="flex flex-col items-end gap-1">
                            {item.price && (
                              <Badge className="bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-gray-800 font-bold">
                                ₹{item.price}
                              </Badge>
                            )}
                            {item.withoutCheese && (
                              <>
                                <Badge className="bg-gray-100 text-gray-700 hover:bg-gray-200 font-semibold text-xs">
                                  W/o Cheese: ₹{item.withoutCheese}
                                </Badge>
                                <Badge className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-800 font-semibold text-xs">
                                  With Cheese: ₹{item.withCheese}
                                </Badge>
                              </>
                            )}
                          </div>
                        </div>
                        {item.description && (
                          <p className="text-sm text-gray-600 mt-2">{item.description}</p>
                        )}
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </TabsContent>
          ))}
        </Tabs>

        {/* Special Notes */}
        <div className="mt-12 grid md:grid-cols-2 gap-6">
          <div className="bg-white rounded-xl p-6 border-2 border-yellow-200 shadow-md">
            <h4 className="font-bold text-xl text-gray-800 mb-3 flex items-center gap-2">
              <span className="text-2xl">🌱</span>
              Dietary Options
            </h4>
            <p className="text-gray-600">
              Without Onion & Garlic options available for all dishes
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 border-2 border-pink-200 shadow-md">
            <h4 className="font-bold text-xl text-gray-800 mb-3 flex items-center gap-2">
              <span className="text-2xl">⏱️</span>
              Preparation Time
            </h4>
            <p className="text-gray-600">
              Order will take minimum 15 mins to serve - Fresh & Hot!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Menu;
